import { Injectable } from '@tanbo/vue-di-plugin'
import { Http, QueryParams } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { TAB_MAP } from '@/views/dashboard/_components/policy-manage/policy-manage.service'
import { router } from '@/router'
import { hasExistingStrategyId } from '@/utils/strategy-id'

export interface EditToListReq {
  path: string
  fromGroupId: string
}

export interface StrategyListReq {
  /** 每页数量 */
  limit?: number
  /** 当前页 */
  page?: number
  /** 策略类型 1-安全防护策略 2- 软件禁用策略 3- 进程控制策略 默认1 */
  strategy_type?: number
  /**
   * 策略类型 4-域名访问控制 7-USB设备管控 12-定时体检,Windows，13-定时查杀,
   * Windows版 14-漏洞修复, Windows版，15-基线扫描, Windows版，16-定时查杀,
   * Linux版，17-漏洞修复,Linux版，18-外设管控, Linux版，19-定时查杀,Mac版，
   * 20-基线扫描,Linux版，21-监控软件配置,window版，22-系统保护、病毒��
   */
  data_type?: number|string
  group_id?: number
  /** 启用分组id查询 因为未分组的id是0，后端无法识别不传和传0，所以加这个字段 */
  apply_group_id_search?: boolean
}

export interface StrategyListDataCommon {
 /** 策略id */
 id: string
 /** 策略名称 */
 name: string
 /** 使用策略的分组数 */
 count: number
 /** 业务条数 */
 data_count: number
 /** 业务条数 临时使用 */
 soft_count: number
 /** 状态 1-启用 0-禁用 */
 status: number
 /** 绑定模式：0-分组模式，1-终端模式 */
 bind_mode?: number
 /** 策略终端应用的设备 deviceId 集合 */
 device_ids?: string[]
 /** 与 device_ids 顺序对应的终端展示名（列表接口可选返回） */
 device_name_list?: string[]
 /** 分组名称列表 */
 group_name_list?: string[]
 /** 优先级 */
 priority?: number
 /** 策略内容(json) ，特定的类型才返回，如软件禁用策略|进程控制策略|域名控制|USB管控 */
 strategy?: string | unknown
 /** 策略触发次数 */
 strategy_trigger_count?: number
}

export interface StrategyListRes {
  /** 总条数 */
  total: number
  /** 策略id */
  data?: StrategyListDataCommon[]
}

export interface UpdateStrategyStatusReq {
  /** 状态 ：1 启用 0 禁用 */
  status: number
  /** 策略id */
  strategy_id?: string
}


export interface SettingsQueryReq {
  id: string
  type: string
}

export interface SettingsResCommon {
  /** 策略id */
  id: string
  /** 策略名称 */
  name: string
  /** 策略内容(json) */
  strategy: any
  /** 策略应用分组id集合 */
  strategy_group_ids?: string[]
  /** 部署的的分组id集合 */
  group_ids?: string[]|number[]
  /** 0-分组模式，1-终端模式 */
  bind_mode?: number
  /** 终端模式下策略应用的 device_id 集合 */
  device_ids?: string[]
}

export interface ModifyPriorityReq {
  /** 策略id */
  id: string
  /** 策略类型 */
  type: number
  /** 策略子类型 */
  data_type: string
  /** 分组id */
  group_id?: number
  /** 下一个更高优先级的策略id */
  next_higher_priority_id?: number
  /** 下一个更低优先级的策略id */
  next_lower_priority_id?: number
  /** 启用分组id查询 因为未分组的id是0，后端无法识别不传和传0，所以加这个字段 */
  apply_group_id_search?: boolean
}

export interface SaveSettingsReq {
  /** 策略id */
  id: string
  /** 策略名称 */
  name?: string
  /** 策略内容(json) */
  strategy: string
  /** 策略类型 */
  type: string
  /** 策略类型 1-安全防护策略 2- 软件禁用策略 */
  strategy_type?: number
  /** 部署的的分组id集合 */
  group_ids: string[]|number[]
  //1、新增文件特征2、删除文件特征3、新增文件路径4、删除文件路径5、新增文件目录6、删除文件目录
  custom_operate_type?: 1|2|3|4|5|6
  /** 0-分组模式，1-终端模式，未传时由 saveSettings 默认 0 */
  bind_mode?: number
  /** 策略应用的设备deviceId集合 */
  device_ids?: string[]
}
export interface getByTypeData {
  /** 策略id */
  id: string
  /** 策略名称 */
  name: string
  /** 使用策略的分组数 */
  count: number
  /** 业务条数 */
  data_count: number
  /** 业务条数 临时使用 */
  soft_count: number
  /** 状态 1-启用 0-禁用 */
  status: number
  /** 策略内容(json) ，特定的类型才返回，如软件禁用策略|进程控制策略|域名控制|USB管控 */
  strategy?: string
}
export interface ResponseGetByTypeData {
  data?: getByTypeData
}
export interface TemplateDownloadRequestParams extends QueryParams {
  template_type: 'domain' | 'ip'
}


export interface TemplateImportParseRes {
  data: string[]
  count: number
  error_detail: string[]
}

/** 将 /strategy/import/parse 返回的 data 规范为去重后的字符串列表 */
export function normalizeTemplateImportData (data: unknown): string[] {
  if (!Array.isArray(data)) return []
  const seen = new Set<string>()
  const out: string[] = []
  for (const item of data) {
    const s = typeof item === 'string' ? item.trim() : String(item ?? '').trim()
    if (!s || seen.has(s)) continue
    seen.add(s)
    out.push(s)
  }
  return out
}

/** 将 error_detail 转为 ExcelImportDialog 的 failedEntries（键为 error_detail 下标 +1，值为错误说明） */
export function errorDetailToFailedEntries (errorDetail: unknown): Record<string, string> {
  if (!Array.isArray(errorDetail)) return {}
  const out: Record<string, string> = {}
  errorDetail.forEach((item, i) => {
    const m = typeof item === 'string' ? item.trim() : String(item ?? '').trim()
    if (!m) return
    out[String(i + 1)] = m
  })
  return out
}

@Injectable()
export class PolicyCommonService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getStrategyList (data: StrategyListReq) {
    return this.http.post<StrategyListRes>('/strategy/list', data).then(response => {
      response.data.forEach(v => {
        v.strategy = JSON.parse(v.strategy || '{}' as any)
      })
      return response
    })
  }

  @InvokeThrottle()
  deleteStrategy (data: { ids?: string[], id?: string }) {
    return this.http.post<void>('/strategy/delete', data)
  }

  @InvokeThrottle()
  updateStrategyStatus (data: UpdateStrategyStatusReq) {
    return this.http.post<void>('/strategy/update_status', data)
  }

  @InvokeThrottle()
  modifyPriority (data: ModifyPriorityReq) {
    return this.http.post<void>('/strategy/modify_priority', data)
  }

  getSettings (options: SettingsQueryReq) {
    return this.http.post<SettingsResCommon>('/strategy/get', options).then(response => {
      response.strategy = JSON.parse(response.strategy || '{}' as any)
      return response
    })
  }

  saveSettings (options: SaveSettingsReq) {
    const isModify = hasExistingStrategyId(options.id)
    const url = isModify ? '/strategy/modify' : '/strategy/save'
    const bind_mode = options.bind_mode ?? 0
    const payload = {
      ...options,
      bind_mode,
      group_ids: bind_mode === 0 ? (options.group_ids ?? []) : [],
      device_ids: bind_mode === 1 ? (options.device_ids ?? []) : [],
    }
    if (!isModify) {
      delete (payload as { id?: string }).id
    }
    return this.http.post(url, payload)
  }
  getByType (data: { type: string, strategy_type?: number }) {
    return this.http.post<ResponseGetByTypeData>('/strategy/get_by_type', data)
  }
  // 下载策略模板（GET + 文件流，与列表导出 downloadWithBlob 类似）
  getStrategyTemplateDownload (params: TemplateDownloadRequestParams) {
    const prefix = params.template_type === 'ip' ? 'ip_strategy_template' : 'domain_strategy_template'
    return this.http.downloadWithBlob('/strategy/template/download', params, prefix)
  }
  // 解析导入的 Excel（multipart，含 file + template_type）
  getStrategyImportParse (formData: FormData) {
    return this.http.postForm<TemplateImportParseRes>('/strategy/import/parse', formData)
  }
}

export function editToList (params: EditToListReq) {
  const { path, fromGroupId } = params
  const query = {
    active_tab: TAB_MAP.terminalView,
    from_group_id: undefined as any,
  }
  // 没有来源终端组，调回策略视图
  if (!fromGroupId) {
    query.active_tab = TAB_MAP.policyView
    // 有来源终端组，跳回终端视图并选中来源终端组
  } else {
    query.active_tab = TAB_MAP.terminalView
    query.from_group_id = fromGroupId
  }
  router.replace({ path, query })
}
